export default {
  newDesign: true,
  title: "Free 1-hour coding class for kids",
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    startBackground: "white",
    quizBackground: "#white",
    title: "Ücretsiz çevrimiçi kodlama ve oyun geliştirme sınıfımıza katılın!",
    subtitle:
      "✏️ Untuk anak usia 8-17 tahun <br>💻 Membuat proyek IT dasar pertamanya <br>💬 Membahas pengalaman dan hobi anak<br>🌐 Hanya diperlukan komputer dan koneksi internet",
    image: {
      url: "/welcome/uk_course_desktop.png",
      style: {
        padding: "28px",
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/test_mobile.png",
      style: {
        width: "100%",
      },
    },
    button: "Book Your Free Trial Class",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Thank you for trusting our educational platform!",
    subtitle:
      "Unfortunately, tablets or phones are not suitable for using our lessons. We will be happy to see you in our classes next time!",
  },
  quizRotateBySteps: {
    1: {
      question: "How does your child spend his/her free time?",
      answers: [
        "🎨 Likes arts: drawing, music, acting",
        "🎮 Plays on the phone or computer",
        "👍 Plays board games",
        "🏅 My child likes sports",
        "🎞️ Watches cartoons and movies",
        "👥 Goes out with friends",
      ],
    },
    2: {
      question: "How does your child spend his/her free time?",
      answers: [
        "🎨 Likes arts: drawing, music, acting",
        "🎮 Plays on the phone or computer",
        "👍 Plays board games",
        "🏅 My child likes sports",
      ],
    },
    3: {
      question: "Why would you like to enroll your child in coding classes?",
      image: {
        answeWithImage: true,
        image_main: "/welcome/testImage.png",
        imageMobile: "",
        isMainImage: true,
        isVideo: false,
      },
      answers: [
        "🎮 My child plays video games a lot",
        "🤪 My child always watches YouTube or TikTok",
        "💡 My child wants to become a coder",
        "❓ Other",
      ],
    },
    4: {
      title: "How old is your child?",
      type: "age",
      button: "",
    },
    5: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/testDiagram.png",
      subtitle:
        "We’re halfway there! We’re almost done designing the personalized trial class for your kid.",
      button: "Let’s make it 100%",
    },
    6: {
      title: "Congratulations!🎉",
      typeInfo: "congrats",
      subtitle: "Click “Book a class 📅” to complete registration",
      button: "Book a class 📅",
    },
    7: {
      title: "Choose date and time",
      type: "one-page-contacts",
      subtitle: "",
      button: "👏 Great. The final step!",
    },
    8: {
      typeInfo: "loaderScreen",
      sliderImages: [
        "/welcome/projectTest.png",
        "/welcome/projectTest2.png",
        "/welcome/projectTest3.png",
      ],
      sliderImagesMobile: [
        "/welcome/projectTestMob.png",
        "/welcome/projectTest2Mob.png",
        "/welcome/projectTest3Mob.png",
      ],
      textLoader: "Creating your child's personalized learning plan",
      titleLoader: "Look what our students have made — your child can, too!",
    },
    9: {
      typeInfo: "loaderScreen",
      sliderImage: "/welcome/loaderTest2.png",
      sliderImageMobile: "/welcome/loaderTest2Mob.png",
      textLoader: "Creating your child's personalized learning plan",
      titleLoader: '<span style="color: rgba(89, 136, 255, 1)">1500+</span> teachers and mentors',
      subtitleLoader: "Trained, passionate, and always in touch with students 💙",
    },
    10: {
      title: "Thank you! Your free trial class has been successfully booked 🎉",
      typeInfo: "pc-laptop",
      subtitle:
        "Please ensure you have a working computer or laptop available for the lesson. It's also important that you accompany your child during the class. Each session is personalized and tailored to your child's needs.",
      button: "What else?",
    },
    11: {
      title: "Before the trial, check your email and WhatsApp for updates 📞",
      typeInfo: "whatsapp",
      subtitle:
        "We'll send you a reminder 24 hours before the class and will request confirmation of your attendance 2 hours prior to the start time. Staying in touch is essential to avoid class cancellation.",
      button: "Great!",
    },
    12: {
      title: "The lesson will take place on our platform 💻",
      typeInfo: "classroom",
      subtitle:
        "You'll get a link and a unique code via WhatsApp and email. Just click the link, it will take you straight to the lesson. No extra apps, no downloads.",
      button: "Got it ✅",
    },
  },
};
